// AC-2924: the text-message disclosure a therapist sees before saving a mobile number.
// Wording approved by the PO; a wording change is an edit to this one line.
const SMS_CONSENT_DISCLOSURE =
  "By giving your mobile number, you agree that Alli Connect may text you about new client referrals and messages. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for help.";

export default SMS_CONSENT_DISCLOSURE;
